export const services = [
  {
    id: 1,
    icon: "ri-brain-line",
    title: "AI Business Consulting",
    description: "We align AI with your business goals: from opportunity assessment and use case prioritization to data readiness, vendor selection, and change management. A clear, actionable AI strategy that delivers value within months.",
    color: "from-amber-500 to-orange-500",
  },
  {
    id: 2,
    icon: "ri-robot-2-line",
    title: "Agentic AI & Intelligent Automation",
    description: "Move beyond simple automation. Build AI agents that perceive, decide, and act independently: autonomous workflow agents, multi-agent enterprise systems, LLM-based reasoning agents, and AI-driven RPA.",
    color: "from-emerald-500 to-teal-500",
  },
  {
    id: 3,
    icon: "ri-chat-ai-line",
    title: "AI Chatbots & Virtual Assistants",
    description: "Engage customers and empower employees with conversational AI. Custom ChatGPT & Copilot-style assistants, voice-enabled agents, omnichannel chatbots, and enterprise knowledge bots built on OpenAI, Azure AI, and more.",
    color: "from-sky-500 to-cyan-500",
  },
  {
    id: 4,
    icon: "ri-global-line",
    title: "AI-Powered Websites & Digital Experiences",
    description: "Your website should be intelligent, not just informative. We build AI-enhanced corporate sites, ecommerce with AI recommendations, dynamic lead generation, SEO + AI content optimization, and headless CMS + AI integration.",
    color: "from-rose-500 to-pink-500",
  },
  {
    id: 5,
    icon: "ri-code-s-slash-line",
    title: "Custom AI Software Development",
    description: "Tailored, scalable, production-ready AI applications: AI-native SaaS platforms, ML models, NLP systems, computer vision solutions, and generative AI apps. Built with Python, LangChain, LlamaIndex, TensorFlow, and React.",
    color: "from-violet-500 to-indigo-500",
  },
  {
    id: 6,
    icon: "ri-graduation-cap-line",
    title: "IT Training & Global Certification",
    description: "Upskill your workforce with world-class AI and IT training programs. From AI literacy workshops to advanced certifications in cloud, cybersecurity, and data science, delivered globally through CPI Academy.",
    color: "from-amber-500 to-yellow-500",
  },
];

export const stats = [
  { value: "28+", label: "Years Experience" },
  { value: "500+", label: "Projects Delivered" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "120+", label: "AI & Tech Experts" },
];

export const portfolio = [
  {
    id: 1,
    title: "Agentic Supply Chain Optimizer",
    category: "Agentic AI",
    description: "Multi-agent AI system for autonomous supply chain decision-making, reducing operational costs by 34% for a Fortune 500 logistics firm.",
    tags: ["LangChain", "Python", "FastAPI", "AWS"],
    image: "https://readdy.ai/api/search-image?query=supply%20chain%20AI%20automation%20dashboard%20futuristic%20dark%20interface%20glowing%20data%20nodes%20network%20connections%20professional%20minimal%20dark%20navy%20background%20wide%20cinematic&width=600&height=400&seq=aiport1&orientation=landscape",
  },
  {
    id: 2,
    title: "Enterprise AI Copilot Platform",
    category: "Generative AI",
    description: "Custom GPT-4 powered copilot for a global bank, handling internal FAQs, compliance queries, and document summarization for 8,000+ employees.",
    tags: ["OpenAI", "Azure AI", "React", "Node.js"],
    image: "https://readdy.ai/api/search-image?query=enterprise%20AI%20copilot%20chat%20interface%20modern%20clean%20dark%20theme%20professional%20banking%20fintech%20minimal%20sleek%20design%20wide&width=600&height=420&seq=aiport2&orientation=landscape",
  },
  {
    id: 3,
    title: "AI-Powered E-Commerce Platform",
    category: "AI Websites",
    description: "Intelligent ecommerce site with AI product recommendations, visual search, and dynamic pricing, boosting conversion by 47% for a national retailer.",
    tags: ["React", "TensorFlow", "Shopify", "Python"],
    image: "https://readdy.ai/api/search-image?query=AI%20ecommerce%20website%20modern%20clean%20interface%20product%20recommendations%20visual%20search%20professional%20minimal%20light%20neutral%20background%20wide&width=600&height=380&seq=aiport3&orientation=landscape",
  },
  {
    id: 4,
    title: "Fraud Detection AI Engine",
    category: "Custom AI Software",
    description: "Real-time ML fraud detection system processing 2M+ daily transactions with 99.2% accuracy for a Chicago-based fintech company.",
    tags: ["PyTorch", "Kafka", "FastAPI", "AWS"],
    image: "https://readdy.ai/api/search-image?query=fraud%20detection%20AI%20machine%20learning%20dashboard%20dark%20professional%20fintech%20security%20monitoring%20real-time%20data%20streams%20minimal%20cinematic%20wide&width=600&height=440&seq=aiport4&orientation=landscape",
  },
  {
    id: 5,
    title: "Healthcare Virtual Assistant",
    category: "AI Chatbots",
    description: "Omnichannel AI assistant for a hospital network, handling appointment booking, symptom triage, and patient FAQs across web, WhatsApp, and Teams.",
    tags: ["Azure AI", "WhatsApp API", "React", "Node.js"],
    image: "https://readdy.ai/api/search-image?query=healthcare%20AI%20chatbot%20virtual%20assistant%20interface%20clean%20white%20medical%20professional%20modern%20minimal%20light%20background%20wide&width=600&height=400&seq=aiport5&orientation=landscape",
  },
  {
    id: 6,
    title: "AI Workforce Upskilling Program",
    category: "IT Training",
    description: "Enterprise-wide AI literacy and certification program for 1,200+ employees across Africa and North America, delivered through CPI Academy.",
    tags: ["AI Training", "i3Cert", "LMS", "Global"],
    image: "https://readdy.ai/api/search-image?query=corporate%20AI%20training%20program%20diverse%20professionals%20learning%20technology%20modern%20classroom%20Chicago%20Lagos%20global%20certification%20professional%20warm%20neutral%20tones%20wide&width=600&height=360&seq=aiport6&orientation=landscape",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Marcus Thompson",
    title: "CTO, NovaBridge Capital",
    avatar: "MT",
    rating: 5,
    text: "CPI Technologies built us an agentic AI system that autonomously manages our entire supply chain decision loop. The ROI was visible within 60 days. Absolutely world-class AI execution.",
    color: "from-orange-400 to-red-500",
  },
  {
    id: 2,
    name: "Priya Sharma",
    title: "VP of Engineering, MedCore Systems",
    avatar: "PS",
    rating: 5,
    text: "The AI copilot they built for our internal teams handles thousands of queries daily without a hiccup. Their team is sharp, communicative, and genuinely cares about the product outcome.",
    color: "from-emerald-400 to-teal-500",
  },
  {
    id: 3,
    name: "James Kowalski",
    title: "CEO, RetailEdge Inc.",
    avatar: "JK",
    rating: 5,
    text: "Our AI-powered website conversion rate jumped 47% in 3 months. CPI's AI consulting team understood our business goals first, then built the technology to match. Best investment we've made.",
    color: "from-amber-400 to-yellow-500",
  },
  {
    id: 4,
    name: "Sarah Chen",
    title: "CISO, LogiFlow Enterprises",
    avatar: "SC",
    rating: 5,
    text: "CPI's fraud detection AI processes millions of our transactions daily with near-perfect accuracy. Their ML team's expertise is genuinely unmatched in the industry.",
    color: "from-sky-400 to-cyan-500",
  },
  {
    id: 5,
    name: "Dr. Emeka Obi",
    title: "Director of Digital Health, Lagos University Hospital",
    avatar: "EO",
    rating: 5,
    text: "CPI Technologies delivered our AI patient assistant on time and on budget. Their global delivery model (Chicago strategy, Lagos execution) is a real competitive advantage.",
    color: "from-rose-400 to-pink-500",
  },
  {
    id: 6,
    name: "Linda Vasquez",
    title: "Head of L&D, TrueNorth Enterprises",
    avatar: "LV",
    rating: 5,
    text: "The AI upskilling program CPI Academy delivered transformed our workforce. 1,200 employees certified in 6 months. The curriculum was practical, current, and immediately applicable.",
    color: "from-violet-400 to-indigo-500",
  },
];

export const academyCourses = [
  {
    id: 1,
    title: "AI & Machine Learning Fundamentals",
    duration: "8 Weeks",
    level: "Beginner",
    price: "$499",
    icon: "ri-brain-line",
  },
  {
    id: 2,
    title: "Agentic AI & LLM Engineering",
    duration: "10 Weeks",
    level: "Advanced",
    price: "$899",
    icon: "ri-robot-2-line",
  },
  {
    id: 3,
    title: "Cloud Architecture & AI Integration",
    duration: "6 Weeks",
    level: "Intermediate",
    price: "$599",
    icon: "ri-cloud-line",
  },
];
